import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import AutomService from "../../../../services/AutomService/AutomService";
import MateService from "../../../../services/MateService/MateService";
import { useNavigate } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import Close from "@material-ui/icons/Close";
import { useSetRecoilState } from 'recoil';
import { alertState } from "../../../../recoil-store/recoil-state";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import QueuePoolService from "../../../../services/QueuePoolService/QueuePoolService";
import VariableService from '../../../../services/VariableService/VariableService';
// Import Helpers
import { checkSpecialCharacter } from '../../../../helpers/helper'

// Import CSS
import './AddNewAutom.css'
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: "#fff",
        marginBottom: 20,
        marginBottom: "14px"
    },
    bottomSection: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        "&:focus": {
            outline: "none",
        },
    },
    submit: {
        color: "white",
        marginLeft: 15,
        backgroundColor: "#079063",
        cursor: "pointer",
    },
    formLabelSemiColon: {
        position: "absolute",
        right: "0",
    },
    formLabel: {
        justifyContent: "left",
        alignItems: "center",
        display: "flex",
        position: "relative",
    },
    option: {
        '& > span': {
            marginRight: 10,
            fontSize: 12,
        },
        fontSize: 13,
        fontWeight: 600,
        color: '#46474E',
    }
}));
const AddNewAutom = (props) => {
    const { selectedAutom, setSelectedAutom, setRefresh, automDetail, setRefreshAutomGroups, selectedGroup } = props
    const history = useNavigate();
    const classes = useStyles();
    const { t } = useTranslation();
    const [typeList, setTypeList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [mates, setMates] = useState([]);
    const [automName, setAutomName] = useState("");
    const [description, setDescription] = useState("");
    const [type, setType] = useState({});
    const [group, setGroup] = useState({});
    // const [integrationType, setIntegrationType] = useState("");
    const [queuePool, setSelectQueuePool] = useState("");
    const [queuePoolData, setQueuePoolData] = useState([]);
    const [selectedMate, setSelectedMate] = useState("");
    // const [triggerType, setTriggerType] = useState({
    //     email: false,
    //     webhook: false,
    //     api: false,
    // });
    const [queueEnable, setQueueEnable] = useState(false);
    const handleClose = () => {
        if (props.setOpenEdit) {
            props.setOpenEdit(false);
        }
        else {
            props.setOpen(false);
            setSelectedAutom({})
        }
    };

    const setAlert = useSetRecoilState(alertState);
    const getListType = async (typeId) => {
        const response = await AutomService.getListType();
        if (response.status) {
            if (Array.isArray(response.data)) {
                setTypeList(response.data);
                let selectedType = response.data.find(x => x.id === typeId)
                if (selectedType) {
                    setType(selectedType);
                }
            }
        }
    };
    const getMates = async (mateId) => {

        const response = await MateService.getAllMates();
        if (response?.status) {
            setMates(response.data);
            if (response.data.length > 0) {
                if (mateId) {
                    let s = response.data.find(x => x.id === mateId)
                    if (s) {
                        setSelectedMate(s);
                    }
                } else {
                    response.data.map((mate) => {
                        if (mate.is_default_device) {
                            setSelectedMate(mate);
                            return
                        }
                    });
                }

            }
        }
    };

    const getQueuePools = async (queuePoolId) => {
        const response = await QueuePoolService.getQueuePool();
        if (response.status) {
            setQueuePoolData(response.data);
            if (queuePoolId) {
                let s = response.data.find(x => x.id === queuePoolId)
                if (s) {
                    setSelectQueuePool(s);
                }
            }
        }
    }

    const getGroups = async (groupId) => {
        const response = await AutomService.getAutomGroups();
        if (response?.status) {
            if (response.data.length) {
                setGroupList(response.data)
                if (groupId) {
                    const findedGroup = response.data.find((x) => x.id === groupId)
                    if (findedGroup) {
                        setGroup(findedGroup)
                        return
                    }
                }
                else if (selectedGroup?.id) {
                    const findedGroup = response.data.find((x) => x.id === selectedGroup.id)
                    if (findedGroup) {
                        setGroup(findedGroup)
                        return
                    }
                }
                setGroup({})
            } else {
                setGroupList([])
            }
        }
    }

    const fetchData = async () => {
        let type_id, autom_group_id, mate_id, qpool_id;
        if (automDetail?.id) {
            const response = await AutomService.getAutomDetail(automDetail.id);
            if (response.status) {
                setAutomName(response.data.name);
                setDescription(response.data.description);
                setQueueEnable(response.data.queue_enabled);

                type_id = response.data.type_id;
                autom_group_id = response.data.autom_group_id;
                mate_id = response.data.mate_id;
                qpool_id = response.data.qpool_id;
            } else {
                // hata yazılacak.
            }
        } else {
            setAutomName("");
            setDescription("");
            setType("");
            setQueueEnable(false);
        }

        await getListType(type_id);
        await getGroups(autom_group_id);
        await getMates(mate_id);
        await getQueuePools(qpool_id);
    }

    useEffect(() => {
        fetchData().then(r => r);
    }, []);

    const handleChange = (event) => {
        setQueueEnable(event.target.checked ? 1 : 0);
    };

    //A new variable will be created when a new trigger flow added.
    async function automaticallyVariableCreation(autom_version_id) {
        const data = {
            name: "triggerParam",
            type: "object",
            type_id: "f1ff5b71-cf84-402b-b73c-eb4e399790b9",
            description: "",
            is_input: 0,
            is_output: 0,
            is_customizable: 0,
            autom_version_id
        };
        const { status } = await VariableService.postVariable(data);
        return status;
    }

    const onSubmit = async () => {
        if (automName.length < 1) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTOMS.AUTOM-NAME-REQUIRED'),
                severity: 'error'
            }));
            return
        } else if (checkSpecialCharacter(automName, true)) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS.NAME-CANNOT-CONTAIN-SPECIAL-CHARACTER"),
                severity: 'error'
            }));
            return;
        } else if (!type || type?.id?.length < 1) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTOMS.AUTOM-TYPE-REQUIRED'),
                severity: 'error'
            }));
            return
        } else if (queueEnable && (!queuePool || queuePool?.id?.length === 0)) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("CONTENT.AUTOMS-LIST.QUEUE-POOL-REQUIRED"),
                severity: 'error'
            }));
            return;
        }
        let mateId = selectedMate ? selectedMate.id : null;
        let qpool_id = queuePool ? queuePool.id : null;
        const name = automName.trim();
        let newFormData = !automDetail?.id ? {
            name,
            description: description,
            type_id: type.id,
            integration_type: 'STANDARD',
            mate_id: mateId,
            queue_enabled: queueEnable,
            qpool_id: qpool_id,
            autom_group_id: group?.id
        } : {
            autom_id: automDetail?.id,
            updatingFields: [
                { field_name: "name", field_value: name },
                { field_name: "description", field_value: description },
                //{field_name: "integration_type", field_value: integrationType},
                { field_name: "mate_id", field_value: mateId },
                { field_name: "queue_enabled", field_value: queueEnable },
                { field_name: "qpool_id", field_value: qpool_id },
                { field_name: "autom_group_id", field_value: group?.id },
            ],
        };

        const response = automDetail?.id ? await AutomService.updateAutom(
            newFormData,
            automDetail?.id
        ) : await AutomService.postAutom(newFormData);
        if (response.status) {

            if (props.setAutomDetail) {
                props.setAutomDetail({
                    ...props.automDetail,
                    name: automName,
                    description,
                    // integration_type: integrationType,
                    // trigger_type: trigger_type,
                    mate_id: mateId,
                    queue_enabled: queueEnable,
                    qpool_id: qpool_id,
                });
                props.setReCheck(!props.reCheck);
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS.AUTOM-EDITED"),
                    severity: 'success'
                }));
                handleClose();
            }
            else {
                if (!automDetail?.id) {
                    history(`/automs/${response.id}/autom/edit`);
                }
                else {
                    if (props.afterSave) {
                        props.afterSave({ id: automDetail.id, name, description, group })
                    }
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t("MESSAGES.AUTOMS.AUTOM-EDITED"),
                        severity: 'success'
                    }));
                    handleClose()
                    setRefreshAutomGroups((pre) => !pre)
                }
            }
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: 'error'
            }));
        }
    };

    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: 400,
                    padding: "8px 14px"
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title" className="add-group-header">
                    <h4 className="autom-group-title">{automDetail?.id ? t("CONTENT.AUTOMS-LIST.EDIT-AUTOM") : t("CONTENT.AUTOMS-LIST.CREATE-NEW-AUTOM")}</h4>
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close className="autom-group-close-button" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ textAlign: "left" }}>
                    <div className="form-element">
                        <div className="modal-text add-group-name">
                            <div>{t("CONTENT.AUTOMS-LIST.AUTOM-NAME")}<span className="mandatory-field">*</span> </div>
                        </div>
                        <small
                            className="conf-field-desc"><em>{t("CONTENT.AUTOMS-LIST.AUTOM-NAME-HELPER", { type: 'string' })}</em></small>
                        <TextField
                            id="filled-size-small"
                            autoFocus
                            style={{
                                backgroundColor: "#fff",
                                width: "100%",
                                marginBottom: "14px"
                            }}
                            value={automName}
                            onChange={(e) => {
                                if (e.target.value.length > 60) {
                                    return setAlert(alert => ({
                                        ...alert,
                                        show: true,
                                        message: t("CONTENT.GENERAL.CHARACTER-LIMIT", { limit: 60 }),
                                        severity: 'error'
                                    }))
                                }
                                setAutomName(e.target.value)
                            }}
                            className={classes.input}
                            variant="outlined"
                            size="small"
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                    </div>

                    {!automDetail?.id && <div className="form-element">
                        <div className="modal-text add-group-name">{t("CONTENT.AUTOMS-LIST.AUTOM-TYPE")}<span className="mandatory-field">*</span> </div>
                        <small
                            className="conf-field-desc"><em>{t("CONTENT.AUTOMS-LIST.AUTOM-TYPE-HELPER", { type: 'string' })}</em></small>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <Autocomplete
                                onChange={(e, newValue) => {
                                    setType(newValue)
                                }}
                                value={type}
                                size="small"
                                classes={{
                                    option: classes.option,
                                }}
                                options={typeList}
                                // getOptionSelected={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.name ?? ""}
                                renderInput={params =>
                                    <TextField {...params} placeholder="No Type Selected" variant="outlined" inputProps={{
                                        ...params.inputProps,
                                        "aria-autocomplete": 'new-password',
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                        style: {
                                            marginLeft: '3px',
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: '#46474E'
                                        }
                                    }} />}
                            />
                        </FormControl>
                    </div>}

                    <div className="form-element add-autom-input">
                        <div className="modal-text add-group-name">
                            {t("CONTENT.AUTOMS-LIST.DESCRIPTION")}
                        </div>
                        <small
                            className="conf-field-desc"><em>{t("CONTENT.AUTOMS-LIST.DESCRIPTION-HELPER", { type: 'string' })}</em></small>
                        <TextField
                            id="filled-size-small"
                            className={classes.input}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            variant="outlined"
                            size="small"
                            multiline
                            rows={5}
                            fullWidth
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                    </div>

                    <div className="form-element">
                        <div className="modal-text add-group-name">{t("CONTENT.AUTOMS-LIST.GROUP-NAME")}</div>
                        <small
                            className="conf-field-desc"><em>{t("CONTENT.AUTOMS-LIST.GROUP-SELECT-HELPER", { type: 'string' })}</em></small>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >

                            <Autocomplete
                                onChange={(e, newValue) => {
                                    setGroup(newValue)
                                }}
                                value={group}
                                size="small"
                                classes={{
                                    option: classes.option,
                                }}
                                options={groupList}
                                getOptionLabel={(option) => option.name ?? ""}
                                renderInput={params =>
                                    <TextField {...params} placeholder="No Group Selected" variant="outlined" inputProps={{
                                        ...params.inputProps,
                                        "aria-autocomplete": 'new-password',
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                        style: {
                                            marginLeft: '3px',
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: '#46474E'
                                        }
                                    }} />}

                            />
                        </FormControl>
                    </div>


                    <div className="form-element">
                        <div className="modal-text add-group-name">Mate</div>
                        <small
                            className="conf-field-desc"><em>{t("CONTENT.AUTOMS-LIST.MATE-HELPER", { type: 'string' })}</em></small>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <Autocomplete
                                onChange={(e, newValue) => {
                                    setSelectedMate(newValue)
                                }}
                                value={selectedMate}
                                size="small"
                                classes={{
                                    option: classes.option,
                                }}
                                options={mates}
                                getOptionLabel={(option) => option.device_name ?? ""}
                                renderOption={(option) => (
                                    <div className="elipsis-nowrap">{option.device_name ?? ""}</div>
                                )}
                                renderInput={params =>
                                    <TextField {...params} placeholder="No Mate Selected" variant="outlined" inputProps={{
                                        ...params.inputProps,
                                        "aria-autocomplete": 'new-password',
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                        style: {
                                            marginLeft: '3px',
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: '#46474E'
                                        }
                                    }} />}

                            />
                        </FormControl>
                    </div>

                    <div className="form-element">
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <FormControlLabel

                                control={
                                    <Checkbox
                                        checked={queueEnable}
                                        size="small"
                                        color="#C4C4C4"
                                        inputName="queueEnable"
                                        onChange={handleChange}
                                    />

                                }
                                label={<div className="modal-text add-group-name">{t("CONTENT.AUTOMS-LIST.QUEUE-ENABLED")}</div>}
                            />
                        </FormControl>
                    </div>
                    {queueEnable ?
                        <div className="form-element">
                            <div className="modal-text add-group-name">{t("CONTENT.AUTOMS-LIST.RELATED-QUEUE-POOL")}</div>
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}
                                style={{ width: "100%" }}
                            >
                                <Autocomplete
                                    onChange={(e, newValue) => {
                                        setSelectQueuePool(newValue)
                                    }}
                                    value={queuePool}
                                    size="small"
                                    classes={{
                                        option: classes.option,
                                    }}
                                    options={queuePoolData}
                                    getOptionLabel={(option) => option.pool_name ?? ""}
                                    renderInput={params =>
                                        <TextField {...params} placeholder="No Queue Pool Selected" variant="outlined" inputProps={{
                                            ...params.inputProps,
                                            "aria-autocomplete": 'new-password',
                                            autoComplete: 'new-password', // disable autocomplete and autofill
                                            style: {
                                                marginLeft: '3px',
                                                fontSize: 12,
                                                fontWeight: 600,
                                                color: '#46474E'
                                            }
                                        }} />}

                                />
                            </FormControl>
                        </div>
                        : null}
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "center",
                    padding: "8px 24px 16px 24px",
                }}
            >
                <div className={classes.bottomSection}>
                    <button
                        type="button"
                        onClick={onSubmit}
                        data-test="createautom-button"
                        className={`button-save`}
                        style={{
                            width: "128px",
                            height: "27px",
                            borderRadius: "4px",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)"
                        }}
                    >
                        {automDetail?.id ? t("CONTENT.AUTOMS-LIST.UPDATE") : t("CONTENT.AUTOMS-LIST.CREATE")}
                    </button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default AddNewAutom;
